import styled from 'styled-components';

import Benefits from 'ggApp/shared/screens/ProductDetailsPage/Benefits';
import WhatsInTheBox from 'ggApp/shared/screens/ProductDetailsPage/WhatsInTheBox';
import CommonFeedbackBanner from 'ggApp/shared/common/FeedbackBanner';
import Player from 'ggApp/shared/screens/ProductDetailsPage/Player';
import ProductSpecs from 'ggApp/shared/screens/ProductDetailsPage/ProductSpecs';
import omitProps from 'ggApp/utils/omitProps';

import BundlesSection from './BundleSection'

export const Container = styled.div`
    position: relative;
    margin: 0 5%;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        background: none;
        padding-bottom: 80px;
    `};
`;

export const Header = styled.div`
    height: 200px;
    display: flex;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        height: 116px;
    `};
`;

export const BackButtonContainer = styled.div`
    align-self: center;
    margin-left: 28px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-left: 0;
    `};
`;

export const ContentWrapper = styled.div`
    grid-area: main;
    grid-row: 2;
`;

export const ProductDetailsContainer = styled.div`
    grid-area: aside;
`;

export const StickyContainer = styled.div`
    position: sticky;
    top: 42px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        position: static;
    `}
`;

export const ProductImagesContainer = styled.div`
    margin: 0 42px 42px 0;
    grid-area: main;
    grid-row: 1;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 0 32px;
    `}
`;

export const Content = styled.div`
    display: grid;
    grid-template-areas:
        ' main main main main main main main . aside aside aside aside '
        ' main main main main main main main . aside aside aside aside ';
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 16px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        display: block;
    `}
`;

export const StickyCtaContainer = styled.div`
    display: none;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
    `}
`;

export const Bundles = styled(BundlesSection)`
    margin: 32px 0;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 16px 0;
    `};
`;

export const StyledBenefitsSection = styled(
    omitProps(
        'isFlexibleProduct',
    )(Benefits),
)`
    margin: 32px 0;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 16px 0;
    `};
`;

export const StyledWhatsInTheBoxSection = styled(WhatsInTheBox)`
    margin: 32px 0;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 16px 0;
    `};
`;

export const TechSpecs = styled(ProductSpecs)`
    margin: 32px 0;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 16px 0;
    `};
`;

export const FeedbackBanner = styled(CommonFeedbackBanner)`
    margin-bottom: ${({ theme }) => theme.spacers.L};

    a {
        color: #FE1251;
        text-decoration: underline;
    }
`;

export const VimeoPlayerWrapper = styled.div`
    position: relative;
    grid-area: v;
    height: 0;
    padding-bottom: 56.25%;
    margin-bottom: 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        grid-column: 1 / -1;
    `}

    ${({ hide }) => hide && `
        padding-bottom: 0;
        margin-bottom: 0;
    `}
`;

export const VimeoPlayer = styled(Player)`
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;
